import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@nucleus-commerce/ui/components/form';
import { Input } from '@nucleus-commerce/ui/components/input';

import { RAIL_LIMIT_MAX, type RailFormInput } from '../../schemas/block-form-schema';

/**
 * How many products the storefront receives. Layout hints (columns, card size) stay in the
 * custom bag on purpose: the storefront owns layout.
 */
export function RailDisplayFields() {
  const { t } = useTranslation('content');
  const form = useFormContext<RailFormInput>();
  const sourceType = useWatch({ control: form.control, name: 'sourceType' });
  const products = useWatch({ control: form.control, name: 'products' });
  const limit = useWatch({ control: form.control, name: 'limit' });
  const limitNumber = /^\d+$/.test(limit) ? Number(limit) : null;

  return (
    <FormField
      control={form.control}
      name="limit"
      render={({ field }) => (
        <FormItem className="max-w-56">
          <FormLabel>{t('rail.limit')}</FormLabel>
          <FormControl>
            <Input {...field} inputMode="numeric" />
          </FormControl>
          <FormDescription>
            {limitNumber !== null
              ? sourceType === 'products'
                ? t('rail.limitHintProducts', { limit: limitNumber, count: products.length })
                : t('rail.limitHintCollection', { limit: limitNumber })
              : t('rail.limitHint', { max: RAIL_LIMIT_MAX })}
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
